import React, { forwardRef } from 'react';
import BaseNumericInput from './BaseNumericInput';
import cn from 'classnames';

const ReadOnlyCurrency = ({ value }) => {
  const readOnlyValue = value ? `$${Number(value).toFixed(2)}` : '$0.00';
  const className = cn('read-only', { empty: !value });

  return <div className={className}>{readOnlyValue}</div>;
};

/**
 *
 * @typedef {React.ComponentProps<BaseNumericInput>} BaseCurrencyInputProps
 * @property {boolean} [spinners={false}] False by default.
 * @property {string} [format='c2'] "c2" be default.
 * @property {number} [min={0}] 0 by default.
 *
 * @param {BaseCurrencyInputProps} props
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement}
 */
const BaseCurrencyInput = ({ readOnly, spinners = false, ...props }, ref) => {
  if (readOnly) {
    return <ReadOnlyCurrency {...props} />;
  }

  return <BaseNumericInput ref={ref} format='c2' min={0} spinners={spinners} {...props} />;
};

/**
 * A base currency input component with various options and handlers.
 *
 * @param {BaseCurrencyInputProps} props Component props. Extends BaseNumericInput's props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement} Base currency input component.
 */
const ForwardCurrencyInput = forwardRef(BaseCurrencyInput);

export default ForwardCurrencyInput;
